import {hasElements} from './hasElements';

const mean = (values: number[]): number => {
    if (!hasElements(values)) return NaN;

    return values.reduce((sum, estimate) => sum + estimate, 0) / values.length;
};

export {mean};
